import { render, staticRenderFns } from "./VideoEducationCategory.vue?vue&type=template&id=9800e460&"
import script from "./VideoEducationCategory.vue?vue&type=script&lang=js&"
export * from "./VideoEducationCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports